import { useState } from "react";
import ModalContato from "../ModalContato";
import { ContainerCard, CardStyle, images } from "../styles";
import { Card } from "antd";

export default function DomPedroLaguna() {
  const { Meta } = Card;

  return (
    <ContainerCard>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/cronogramas/cronogram-pedro-laguna-26-cotas.pdf">
            <img
              alt="cronograma"
              src={images.calendario}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Cronograma - 26 Cotas"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/cronogramas/cronogram-pedro-laguna-52-cotas.pdf">
            <img
              alt="cronograma"
              src={images.calendario}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Cronograma - 52 Cotas"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
    </ContainerCard>
  );
}
